/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ChooseOrganizerMenuQueryVariables = {
    organizerSlug: string;
};
export type ChooseOrganizerMenuQueryResponse = {
    readonly organizer_connection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly name: string;
                readonly cuid: string;
            };
        }>;
    };
};
export type ChooseOrganizerMenuQuery = {
    readonly response: ChooseOrganizerMenuQueryResponse;
    readonly variables: ChooseOrganizerMenuQueryVariables;
};



/*
query ChooseOrganizerMenuQuery(
  $organizerSlug: String!
) {
  organizer_connection(where: {slug: {_eq: $organizerSlug}}) {
    edges {
      node {
        name
        cuid
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizerSlug"
        } as any
    ], v1 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "_eq",
                            "variableName": "organizerSlug"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "slug"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cuid",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ChooseOrganizerMenuQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "organizerConnection",
                    "kind": "LinkedField",
                    "name": "organizer_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "organizerEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "organizer",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "query_root",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ChooseOrganizerMenuQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "organizerConnection",
                    "kind": "LinkedField",
                    "name": "organizer_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "organizerEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "organizer",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "0a376743fb840d1fa6f2cabbff8cac3a",
            "id": null,
            "metadata": {},
            "name": "ChooseOrganizerMenuQuery",
            "operationKind": "query",
            "text": "query ChooseOrganizerMenuQuery(\n  $organizerSlug: String!\n) {\n  organizer_connection(where: {slug: {_eq: $organizerSlug}}) {\n    edges {\n      node {\n        name\n        cuid\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '1db85ba23d02c8053fbd061a497c0bc0';
export default node;
